const removeInfinity = (val, fallback) => {
  if (!Number.isFinite(val)) {
    return fallback
  }

  return val
}

export default removeInfinity
